/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { ReactComponent as Logo } from 'assets/QUID.svg'
import { setAutoId, AutomationId } from 'utils/automationUtil'

const { dark } = sys

const Container = styled.div`
  background-color: ${dark.elevation[100].background};
  height: 100vh;
  color: ${dark.text.primary};
`

const Header = styled.div`
  background-color: ${dark.elevation[0].background};
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  margin: 100px auto;
  width: 480px;
  text-align: center;
`

interface SystemMessageLayoutProps {
  children: React.ReactNode
}

const SystemMessageLayout = ({ children }: SystemMessageLayoutProps) => (
  <Container>
    <Header>
      <Logo {...setAutoId(AutomationId.systemMessage.logo)} />
    </Header>
    <Content>{children}</Content>
  </Container>
)

export default SystemMessageLayout
